import React, { useCallback, useEffect, useState, useRef  } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  AddBooking,
  areaCodeListSelector,
  DeleteCartItem,
  deleteStudentListing,
  eventTotalInCartSelector,
  FetchAreaCodeList,
  FetchCartEventList,
  FetchUserDetail,
  GetCartClassList,
  GetCartClassListSelector,
  GetCartTotalSelector,
  getEventAddedToCartListSelector,
  GetStudentList,
  MonthlyDateClassList,
  monthlyListSelector,
  removeStudentLisitng,
  SchoolList,
  schoolListSelector,
  studentListSelector,
  userDetailSelector,
  FetchCompanySetting,
  companySettingsSelector,
} from "../slice";
import Carousel from "react-multi-carousel";
import { responsive } from "../../utils";
import StudentCard from "../../component/student/StudentCard";
import { useToggle } from "../../utils/hooks";
import moment from "moment";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import Delete from "../../component/Modal/Delete";
import Spinner from "react-bootstrap/Spinner";
import { addEventToCart, removeFromEventCart } from "../../api/Events";
import {
  FetchDefaultEventList,
  getEventLists,
  setEventDetail,
} from "../event/EventSlice";
import EventLevels from "../../component/Modal/EventLevels";
import Loader from "./../../component/Loader";
function BookClass() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userDetail = useSelector(userDetailSelector);
  const studentList = useSelector(studentListSelector);
  const companySettings = useSelector(companySettingsSelector);
  const [student, setStudent] = useState([]);
  const defaultEventList = useSelector(getEventLists);
  const schoolList = useSelector(schoolListSelector);
  // const monthlyList = useSelector(monthlyListSelector);
  const totalCartAmount = useSelector(GetCartTotalSelector);
  const totalEventAmount = useSelector(eventTotalInCartSelector);
  const cartList = useSelector(GetCartClassListSelector);
  const cartEventList = useSelector(getEventAddedToCartListSelector);
  const areacodeList = useSelector(areaCodeListSelector);
  const [selectedTiming, setSelectedTiming] = useState([]);
  const [open, toggle] = useToggle(false);
  const [show, toggle2] = useToggle(false);
  const [openClassFor, setOpenClassFor] = useState("");
  const [index, setIndex] = useState(0);
  const [child_price, setChild_price] = useState("");
  const [adult_price, setAdult_price] = useState("");
  const [delId, setDelId] = useState("");
  const [delOpen, delToggle] = useToggle(false);
  const [loading, setLoading] = useState(true);
  const [teacherId, setTeacherId] = useState("");
  const [showArea, setshowArea] = useState(true);
  const [areaId, setAreaId] = useState("");
  const [levelShow, setLevelShow] = useState(false);
  const [levels, setLevels] = useState([]);
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [discipline, setDiscipline] = useState("");
  const [class_type, setClass_type] = useState("");
  const [age_group, setAge_group] = useState("");
  const [classListLoader, setClassListLoader] = useState(false);
  const [monthlyList, setMonthlyList] = useState([]);
  const [addToCartSubmitting, setAddToCartSubmitting] = useState(false);
  const [isActiveMembership, setIsActiveMembership] = useState(false);
  const [isTrialConsumed, setIsTrialConsumed] = useState(false);
  const [isShowmembershipExtend, setIsShowmembershipExtend] = useState(false);
  const [isShowmembershipPurchase, setIsShowmembershipPurchase] = useState(false);
  const [isShowmembershipRenew, setIsShowmembershipRenew] = useState(false);
  useEffect(() => {
    dispatch(FetchUserDetail({}));
    dispatch(FetchCompanySetting());
  }, [dispatch]);

  // Uncheck every selected time slot - used when the extend membership modal opens
  const clearAllSelectedTimeSlots = () => {
    setMonthlyList((prev) =>
      (prev || []).map((itemm) => ({
        ...itemm,
        time_slot_list: itemm?.time_slot_list?.map((ti) => ({
          ...ti,
          time_slot: ti?.time_slot?.map((inner) => ({ ...inner, checked: false })),
        })),
      }))
    );
    setSelectedTiming([]);
    document
      .querySelectorAll("input[type='checkbox'].checkBoxClass")
      .forEach((cb) => {
        cb.checked = false;
      });
  };

  useEffect(() => {
    if (isShowmembershipExtend) {
      clearAllSelectedTimeSlots();
    }
  }, [isShowmembershipExtend]);

  const studnet = useCallback(() => {
    setLoading(true);
    dispatch(GetStudentList({})).then((res) => {
      // REMOVED: Auto-selection logic (Jan 9, 2026)
      // Previously, this function would automatically select a student on page load:
      // 1. If a student was saved in localStorage, it would restore that selection
      // 2. If no saved student, it would auto-select the first student from the list
      // 3. It would also auto-populate: discipline, class_type, showArea, age_group, areaId, schoolId
      // 
      // This was removed to require manual student selection by the user.
      // Users must now explicitly select a student to view the class list.
      //
      // Previous logic:
      // const savedStudent = localStorage.getItem('selectedStudent');
      // if (savedStudent) {
      //   const parsedStudent = JSON.parse(savedStudent);
      //   const updatedStudentFromAPI = res?.payload?.data?.student_list?.find(
      //     apiStudent => apiStudent.id === parsedStudent[0]?.id
      //   );
      //   if (updatedStudentFromAPI) {
      //     setStudent([updatedStudentFromAPI]);
      //     localStorage.setItem('selectedStudent', JSON.stringify([updatedStudentFromAPI]));
      //     setDiscipline(updatedStudentFromAPI?.discipline);
      //     setClass_type(updatedStudentFromAPI?.student_type);
      //     setshowArea(true);
      //     setAge_group(updatedStudentFromAPI?.student_type);
      //     setAreaId(updatedStudentFromAPI?.areacode);
      //     setSchoolId(updatedStudentFromAPI?.schoolId);
      //   } else {
      //     setStudent([{ ...res?.payload?.data?.student_list?.[0] }]);
      //     setDiscipline(res?.payload?.data?.student_list?.[0]?.discipline);
      //     setClass_type(res?.payload?.data?.student_list?.[0]?.student_type);
      //     setshowArea(true);
      //     setAge_group(res?.payload?.data?.student_list?.[0]?.student_type);
      //     setAreaId(res?.payload?.data?.student_list?.[0]?.areacode);
      //     setSchoolId(res?.payload?.data?.student_list?.[0]?.schoolId);
      //   }
      // } else {
      //   setStudent([{ ...res?.payload?.data?.student_list?.[0] }]);
      //   setDiscipline(res?.payload?.data?.student_list?.[0]?.discipline);
      //   setClass_type(res?.payload?.data?.student_list?.[0]?.student_type);
      //   setshowArea(true);
      //   setAge_group(res?.payload?.data?.student_list?.[0]?.student_type);
      //   setAreaId(res?.payload?.data?.student_list?.[0]?.areacode);
      //   setSchoolId(res?.payload?.data?.student_list?.[0]?.schoolId);
      // }
      
      setLoading(false);
    });
  }, [dispatch]);

  const selectRefs = useRef({});
  const setSelectRef = (id) => (el) => {
    selectRefs.current[id] = el; // Assign ref dynamically based on the unique ID
  };

  const handleSelectAllChange = (id, div, isClassAvailableTillMembershipDate, checkboxId) => {

      if(isTrialConsumed && companySettings?.membership == 1){
        document.getElementById(checkboxId).checked = false;
        setIsShowmembershipPurchase(true)
        //toast.error("You have consumed your trial account lessons. Kindly upgrade your membership to start booking."); return
      }else if(!isActiveMembership && companySettings?.membership == 1){
        document.getElementById(checkboxId).checked = false;
        setIsShowmembershipRenew(true)
        //toast.error("Your membership is expired. Kindly renew your membership to start booking."); return
      }else if(!isClassAvailableTillMembershipDate && companySettings?.membership == 1){
        document.getElementById(id).checked = false;
        setIsShowmembershipExtend(true)
        //toast.error("No available classes before your membership expiry date. Kindly upgrade your membership to start booking."); return
      }else{
        
      }


      console.log(div);
      const div_section = document.getElementById(div);
      const checkboxes = div_section.querySelectorAll("input[type='checkbox']");
      const shouldCheck = selectRefs.current[id]?.checked;
      
      // If trying to check all, first validate all time slots have available seats
      if (shouldCheck) {
        // Find the time slot data by parsing the div id
        const timeSlotId = div.replace('schoolClass', '');
        let hasUnavailableSlot = false;
        let unavailableSlotDate = '';
        
        // Find the corresponding time slot item in monthlyList
        for (let classItem of monthlyList) {
          const timeSlotItem = classItem?.time_slot_list?.find(ts => ts.id == timeSlotId);
          if (timeSlotItem) {
            // Check if any time slot doesn't have available seats
            for (let slot of timeSlotItem?.time_slot || []) {
              if (!(slot?.available_seats > 0 && slot?.available_seats <= classItem?.total_seats)) {
                hasUnavailableSlot = true;
                unavailableSlotDate = slot?.date || '';
                break;
              }
            }
            break;
          }
        }
        
        // If any slot doesn't have available seats, uncheck the select all and show error
        if (hasUnavailableSlot) {
          document.getElementById(checkboxId).checked = false;
          selectRefs.current[id].checked = false;
          toast.error(`This session ${unavailableSlotDate} is full, so you cannot book this term. Please contact us for availability.`, {
            autoClose: false
          });
          return;
        }
      }
      
      // Use a loop with setTimeout for a 1-second delay between each checkbox click
      checkboxes.forEach((checkbox) => {
        console.log(123)
        console.log(checkbox.checked, 'checkbox.checked')
        console.log(shouldCheck, 'shouldCheck')
        setTimeout(() => {
          if (checkbox.checked !== shouldCheck) {
          //  if (shouldCheck) {
            console.log(345)
            checkbox.disabled = false;
            checkbox.click(); // Trigger the click event to invoke the onChange handler
            checkbox.disabled = true;
          }
        }, 500); // Delay based on the index
      });
  };
  

  useEffect(() => {
    studnet();
  }, [studnet]);

  const getClassList = useCallback(() => {
    if (discipline && schoolId && class_type) {
      setClassListLoader(true);
      dispatch(
        MonthlyDateClassList({
          page: 1,
          limit: 10000000000,
          schoolId,
          discipline,
          studentId: student?.[0]?.id || "",
          class_type: class_type,
        })
      ).then((res) => {
        setClassListLoader(false);
        if (res?.payload?.code === 1) {
          let arr = res?.payload?.data?.class_list?.map((item) => {
            let innerArr = item?.time_slot_list?.map((ti) => {
              let aa = ti?.time_slot?.map((inner) => {
                return {
                  ...inner,
                  checked: false,
                };
              });
              return {
                ...ti,
                time_slot: aa,
              };
            });

            return {
              ...item,
              time_slot_list: innerArr,
            };
          });
          setMonthlyList(arr);
        }
      });
    }
  }, [dispatch, schoolId, discipline, student, class_type]);

  useEffect(() => {
    getClassList();
  }, [getClassList]);

  useEffect(() => {
    return () => {
      dispatch(removeStudentLisitng(null));
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(FetchAreaCodeList({}));
    setshowArea(true);
  }, [dispatch, student]);
  
  useEffect(() => {
    dispatch(SchoolList({ areacode: areaId, status: 1 }));
  }, [dispatch, areaId]);

  const getCart = useCallback(() => {
    dispatch(GetCartClassList({}));
    dispatch(FetchCartEventList({}));
  }, [dispatch]);

  const getEvents = useCallback(() => {
    if (schoolId) {
      dispatch(
        FetchDefaultEventList({
          page: 1,
          limit: 1000,
          studentId: student?.length > 0 ? student?.[0]?.id : "",
          discipline,
          schoolId,
          age_group,
        })
      );
    }
  }, [dispatch, student, discipline, schoolId, age_group]);

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  useEffect(() => {
    getCart();
  }, [getCart]);

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return (
      <div className="carousel-button-group top-0" style={{ right: 0 }}>
        <button
          onClick={() => previous()}
          className={"slick-prev slick-arrow"}
          aria-label="Previous"
          type="button"
        >
          Previous
        </button>
        <button
          onClick={() => next()}
          className="slick-next slick-arrow"
          aria-label="Next"
          type="button"
        >
          Next
        </button>
      </div>
    );
  };

  const handleTimeSlot = (e, item, classes, outerIndex, innerIndex) => {
    const checked = e.target.checked;

    let st = [...student];

    console.log('my console->',st)

    const addTimings = () => {
      let arr = [...monthlyList];

      if (checked) {
        let arr2 = arr?.map((itemm) => {
          let innerArr = itemm?.time_slot_list?.map((ti) => {
            let aa = ti?.time_slot?.map((inner) => {
              if (
                inner?.classId?.toString() === item?.classId?.toString() &&
                inner?.time_slot_id?.toString() ===
                  item?.time_slot_id?.toString() &&
                inner?.date?.toString() === item?.date?.toString() &&
                inner?.start_time?.toString() ===
                  item?.start_time?.toString() &&
                inner?.end_time?.toString() === item?.end_time?.toString()
              ) {
                return {
                  ...inner,
                  checked: true,
                };
              }
              return inner;
            });
            return {
              ...ti,
              time_slot: aa,
            };
          });

          return {
            ...itemm,
            time_slot_list: innerArr,
          };
        });
        setMonthlyList(arr2);
        let timingsArr = [...selectedTiming];

        timingsArr?.push(1);
        setSelectedTiming(timingsArr);

        setMonthlyList(arr2);

        // arr?.[outerIndex].time_slots?.[innerIndex]?.checked: true
      } else {
        let arr2 = arr?.map((itemm) => {
          let innerArr = itemm?.time_slot_list?.map((ti) => {
            let aa = ti?.time_slot?.map((inner) => {
              if (
                inner?.classId?.toString() === item?.classId?.toString() &&
                inner?.time_slot_id?.toString() ===
                  item?.time_slot_id?.toString() &&
                inner?.date?.toString() === item?.date?.toString() &&
                inner?.start_time?.toString() ===
                  item?.start_time?.toString() &&
                inner?.end_time?.toString() === item?.end_time?.toString()
              ) {
                return {
                  ...inner,
                  checked: false,
                };
              }
              return inner;
            });
            return {
              ...ti,
              time_slot: aa,
            };
          });

          return {
            ...itemm,
            time_slot_list: innerArr,
          };
        });
        let timingsArr = [...selectedTiming];
        if (timingsArr?.length > 0) {
          timingsArr?.splice(0, 1);
          setSelectedTiming(timingsArr);
        }
        setMonthlyList(arr2);
      }
    };

    let isTrailAvailable = st.every((element) => {
      return element.trialAccountStatus === "1";
    });

    let membershipPurchased = st.every((element) => {
      return element.trialAccountStatus === "3";
    });

    let trailUtlized = st.every((element) => {
      return element.trialAccountStatus === "2";
    });
    let stud = st?.[0];
    console.log('stud--', stud);
    console.log('total--', selectedTiming?.length +' '+ stud?.no_of_item_in_cart +' '+ stud?.no_of_bookings)

    if (checked) { 
      // Check if this is a trial class for the student
      if(stud?.schoolId == item?.schoolId){
        // Student has trial class assigned for this class
        if (companySettings?.trial_apply == 1 && companySettings?.membership == 1) { 
          // Both trial and membership features are enabled
          if (isTrailAvailable) { 
            // Student has active trial
            if (selectedTiming?.length + stud?.no_of_item_in_cart + stud?.no_of_bookings < stud?.trial_class_quantity) {
              addTimings();
            } else { 
              e.preventDefault();
              e.stopPropagation();
              e.target.checked = false;
              toast.error("Your tester session are used.", {  autoClose: false,  closeButton: true});
            }
          } else if (trailUtlized) {
            // Trial is utilized, check if they have membership
            if (membershipPurchased) {
              addTimings();
            } else {
              e.preventDefault();
              e.stopPropagation();
              e.target.checked = false;
              toast.error("Your tester session are used. Please purchase a membership.", {  autoClose: false,  closeButton: true});
              setIsShowmembershipPurchase(true);
            }
          } else if (membershipPurchased) {
            // No active trial but has membership
            addTimings();
          } else {
            e.preventDefault();
            e.stopPropagation();
            e.target.checked = false;
            toast.error("Please purchase a membership to continue.", {  autoClose: false,  closeButton: true});
            setIsShowmembershipPurchase(true);
          }
        } else if (companySettings?.trial_apply == 1 && companySettings?.membership == 0) {
          // Only trial is enabled, membership disabled
          if (isTrailAvailable) {
            if (selectedTiming?.length + stud?.no_of_item_in_cart + stud?.no_of_bookings < stud?.trial_class_quantity) {
              addTimings();
            } else {
              e.preventDefault();
              e.stopPropagation();
              e.target.checked = false;
              toast.error("Your tester session are used.", {  autoClose: false,  closeButton: true});
            }
          } else {
            // Trial used and membership is disabled, allow booking
            addTimings();
          }
        } else {
          // Trial is disabled, treat as regular class
          if (companySettings?.membership == 1) {
            if (membershipPurchased) {
              addTimings();
            } else {
              e.target.checked = false;
              setIsShowmembershipPurchase(true);
            }
          } else {
            addTimings();
          }
        }
      } else {
        // Not a trial class for this student
        if(companySettings?.membership == 1){
          if(membershipPurchased){
            addTimings();
          }else{
            e.target.checked = false;
            setIsShowmembershipPurchase(true);
          }
        }else{
          addTimings();
        }
      }
      
      // if (isTrailAvailable && companySettings?.membership == 1 && stud?.trial_class_id == item?.classId) { 
      //   if ( selectedTiming?.length + stud?.no_of_item_in_cart + stud?.no_of_bookings < stud?.trial_class_quantity) {
      //     addTimings();
      //   } else {
      //     e.target.checked = false; // Uncheck the checkbox
      //     toast.error(
      //       "Your tester session are used."
      //     );
      //   }
      // } else if (membershipPurchased && companySettings?.membership == 1) { 
      //   addTimings();
      //   console.log(1);
      // } else if (trailUtlized) { 
      //   console.log(2);
      //   e.target.checked = false; // Uncheck the checkbox
      //   toast.error("You have utilised all trial lessons.");
      //  } 
      //  else if (!isTrailAvailable && companySettings?.trial_apply == 1) { 
      //     console.log(3);
      //     e.target.checked = false; // Uncheck the checkbox
      //     toast.error(
      //       "Your tester session are used."
      //     );
      // }
      // else{ 
      //   if(companySettings?.membership == 1){
      //     setIsShowmembershipPurchase(true)
      //   }else{
      //     addTimings();
      //   }
      // }
    }
  }

  const handleAddToCart = () => {
    setAddToCartSubmitting(true);
    const addTimeSlots = () => {
      let arr = [...student].map((item) => {
        return {
          studentId: item?.id,
          student_type: item?.student_type,
          bookedInTrialAccount: item?.trialAccountStatus === "1" && companySettings?.trial_apply == 1 ? true : false,
        };
      });
      let arr2 = [...monthlyList]
        ?.map((item) => {
          let time_slots = [];

          item?.time_slot_list?.forEach((time) => {
            time?.time_slot?.forEach((slot) => {
              if (slot?.checked) {
                time_slots?.push({
                  date: slot?.date,
                  start_time: moment(slot?.start_time, "HH:mm:ss").format(
                    "HH:mm:ss"
                  ),
                  end_time: moment(slot?.end_time, "HH:mm:ss").format(
                    "HH:mm:ss"
                  ),
                  time_slot_for: slot?.time_slot_for,
                  time_slot_id: slot?.time_slot_id,
                });
              }
            });
          });

          // Check if any student is booking in trial account
          const hasTrialStudent = companySettings?.trial_apply == 1 && arr.some(s => s.bookedInTrialAccount);
          const childPrice = hasTrialStudent ? item?.free_class_charge : item?.child_price;
          const adultPrice = hasTrialStudent ? item?.free_class_charge_adult : item?.adult_price;

          return {
            classId: item?.id,
            teacherId: item?.assigned_teacher_id,
            child_price: childPrice,
            adult_price: adultPrice,
            time_slots,
          };
        })
        ?.filter((it) => it?.time_slots?.length > 0);

      dispatch(
        AddBooking({
          schoolId,
          areacode: areaId,
          students: JSON.stringify(arr),
          class_items: JSON.stringify(arr2),
        })
      )
        .then((res) => {
          setAddToCartSubmitting(false);

          if (res?.payload?.code === 1) {
            if (
              res?.payload?.message
                ?.toLowerCase()
                ?.includes(
                  "Your tester sessions are used"
                )
            ) {
              toast.error(res?.payload?.message, {  autoClose: false,  closeButton: true});
            } else {
              toast.success(res?.payload?.message, {  autoClose: false,  closeButton: true});
            }
          } else {
            toast.error(res?.payload?.message, {  autoClose: false,  closeButton: true});
          }
        })
        .then(() => {
          setStudent([]);
          setSelectedTiming([]);
          setMonthlyList([]);
          setSchoolId(null);
          setAreaId("");
          setshowArea(false);
          setDiscipline("");
          setClass_type("");
          studnet();
          dispatch(deleteStudentListing([]));
          dispatch(GetStudentList({}));
          //window.location.reload();
        });
    };
    if (teacherId) {
      if (student.length > 0) {
        addTimeSlots();
      } else {
        toast.error("Kindly select a student.", {  autoClose: false,  closeButton: true});
      }
    } else {
      toast.error(
        "No teacher available for this class. Kindly select another class.", {  autoClose: false,  closeButton: true}
      );
    }
  };

  const isItemAdded = () => {
    if (monthlyList.length > 0) {
      let selectedTiming = [];

      [...monthlyList]?.forEach((item) => {
        // return {
        //   date: item?.date,
        //   start_time: moment(item?.start_time, "HH:mm:ss").format("HH:mm:ss"),
        //   end_time: moment(item?.end_time, "HH:mm:ss").format("HH:mm:ss"),
        //   time_slot_for: item?.time_slot_for,
        //   time_slot_id: item?.time_slot_id,
        // };

        item?.time_slot_list?.forEach((time) => {
          if (time?.time_slot?.length > 0) {
            time?.time_slot?.forEach((slot) => {
              if (slot?.checked) {
                selectedTiming.push("checked");
              }
            });
          }
        });
      });

      return selectedTiming?.length > 0 ? true : false;
    }
  };

  const showAddToCart = isItemAdded();

  const confirmDelete = () => {
    dispatch(DeleteCartItem({ cart_id: JSON.stringify(delId) })).then((res) => {
      if (res?.payload?.code === 1) {
        dispatch(deleteStudentListing([]));
        dispatch(GetStudentList({}));
        studnet();

        setSelectedTiming([]);
        getCart();
        getClassList();

        toast.success(res?.payload?.message, {  autoClose: false,  closeButton: true});
      } else {
        toast.error(res?.payload?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  const handleRemoveEventFromCart = () => {
    removeFromEventCart({ cart_id: JSON.stringify(delId) }).then((res) => {
      if (res?.code === 1) {
        toast.success(res?.message, {  autoClose: false,  closeButton: true});
        dispatch(GetStudentList({}));
        getCart();
        getEvents();
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  const handleAddEventToCart = (evnt, levl, _child_price, _adult_price) => {
    let membershipPurchased = student.every((element) => {
      return element.trialAccountStatus === "3";
    });

    const eventtocart = () => {
      let payload = {};
      if (evnt?.teacher_details !== null) {
        payload = {
          areacode: evnt?.areacode_details?.id,
          schoolId: evnt?.schoolId,
          eventId: evnt?.id,
          date: evnt?.date,
          area: evnt?.areacode_details?.id,
          age_group: evnt?.age_group,
          teacherId: evnt?.teacher_details?.id,
          price:
            evnt?.levels?.length > 0
              ? ""
              : student?.[0]?.student_type === "child"
              ? evnt?.child_price
              : student?.[0]?.student_type === "adult"
              ? evnt?.adult_price
              : "",
          students: JSON.stringify(
            student?.map((it) => {
              return { studentId: it.id.toString() };
            })
          ),
          levels:
            levl?.length > 0
              ? JSON.stringify(
                  levl?.map((it) => {
                    return {
                      id: it?.id,
                      price:
                        student?.[0]?.student_type === "child"
                          ? it?.child_price
                          : student?.[0]?.student_type === "adult"
                          ? it?.adult_price
                          : "",
                    };
                  })
                )
              : JSON.stringify([]),
        };
      } else {
        payload = {
          areacode: evnt?.areacode_details?.id,
          schoolId: evnt?.schoolId,
          eventId: evnt?.id,
          date: evnt?.date,
          area: evnt?.areacode_details?.id,
          age_group: evnt?.age_group,
          price:
            evnt?.levels?.length > 0
              ? ""
              : student?.[0]?.student_type === "child"
              ? evnt?.child_price
              : student?.[0]?.student_type === "adult"
              ? evnt?.adult_price
              : "",
          students: JSON.stringify(
            student?.map((it) => {
              return { studentId: it.id.toString() };
            })
          ),
          levels:
            levl?.length > 0
              ? JSON.stringify(
                  levl?.map((it) => {
                    return {
                      id: it?.id,
                      price:
                        student?.[0]?.student_type === "child"
                          ? it?.child_price
                          : student?.[0]?.student_type === "adult"
                          ? it?.adult_price
                          : "",
                    };
                  })
                )
              : JSON.stringify([]),
        };
      }

      addEventToCart(payload).then((res) => {
        if (res?.code === 1) {
          if (
            res?.message
              ?.toLowerCase()
              ?.includes(
                "Your tester sessions are used."
              )
          ) {
            toast.error(res?.message, {  autoClose: false,  closeButton: true});
          } else {
            toast.success(res?.message, {  autoClose: false,  closeButton: true});
          }
          getEvents();
          dispatch(GetCartClassList({}));
          dispatch(FetchCartEventList({}));
          setSelectedLevels([]);
          setLevelShow(false);
          setSelectedEvent(null);
        } else {
          toast.error(res?.message, {  autoClose: false,  closeButton: true});
        }
      });
    };

    if (cartList?.includes(evnt)) {
      toast.error("Item already added in the cart. Kindly ", {  autoClose: false,  closeButton: true});
    } else {
      if (student?.length === 0) {
        toast.error("Kindly select a student for the event.", {  autoClose: false,  closeButton: true});
      } else {
        if (membershipPurchased || companySettings?.membership == 1) {
          eventtocart();
        } else {
          toast.error(
            "Kindly upgrade to full membership to purchase the event.", {  autoClose: false,  closeButton: true}
          );
        }
      }
    }
  };

  const ActiveMember = useCallback(() => {
    const arr = [...student];
    let ab = arr.every((it) => {
      console.log(it, "Student selected");
      if(companySettings?.membership == 1){
        return true;
      }else if (it?.membership_details && it?.trialAccountStatus === "3") {
        const expiryDate = moment(it?.membership_details?.valid_till);
        const today = moment();
        let difference = moment.duration(expiryDate.diff(today)).asHours();
        console.log(difference, "Diff");

        if (difference >= 1) {
          return true;
        }
      } else if (it?.trialAccountStatus === "1") return true;
      return false;
    });

    console.log(ab, "Ab value");

    return ab;
  }, [student]);

  const ClassTillMembership = (i) => {
    if (monthlyList?.length > 0 && student?.length > 0) {
      let arr = [...student];

      let arr2 = [...monthlyList];
      console.log('This is i==', i)
      console.log(arr, arr2, "MOnthly list and student");

      let obj = arr2.find((it, ind) => i === ind);
      console.log(obj)
      if (obj && obj?.time_slot_list?.length > 0) {
        return true;
      } else {
        return false;
      }
    }
  };

  const TrialConsumed = useCallback(() => {
    const arr = [...student];
    let ab = arr.every((it) => {
      console.log(it, "Student selected");
      if (it?.trialAccountStatus === "2") {
        return true;
      }
      return false;
    });

    return ab;
  }, [student]);

  useEffect(() => {
    if (student?.length > 0) {
      let ab = ActiveMember();
      console.log(ab, "Is active member");
      setIsActiveMembership(ab);
      let aa = TrialConsumed();

      setIsTrialConsumed(aa);
    }
  }, [student?.length, isActiveMembership, ActiveMember, TrialConsumed]);

  // const isActiveMembership = isInactiveMember();

  return (
    <>
    <section className="sec-bg py-4 px-3 bottom-space">
      <div className="container-fluid">
        <div className="row">
          {userDetail?.consent?.length === 0 && (
            <div className="cols-m-12 text-center dangerMessage">
              {userDetail?.consent?.length === 0 ? (
                <span className="">
                  You may not be able to make bookings if you have not entered
                  your consent preferences in 'Edit Profile' –{" "}
                  <span
                    onClick={() => {
                      navigate("/edit-profile");
                    }}
                    className="cursor-pointer"
                  >
                    <b>Click here</b>
                  </span>
                  .
                </span>
              ) : (
                ""
              )}
            </div>
          )}
          <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
            <h3>Booking Page</h3>
            <p>Which Student to Book For</p>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-8 col-xl-9 mb-3">
            <div className="row align-items-center">
              <div className="col-sm-12 col-md-12 col-lg-12 mt-3"></div>
              {loading ? (
                <div className="col-sm-12 text-center">
                  <Spinner animation="grow" />
                </div>
              ) : (
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3 position-relative">
                  <div className="owl-slider Studentevent-slider student-container">
                    {studentList?.length > 0 ? (
                      <Carousel
                        responsive={responsive}
                        renderButtonGroupOutside={true}
                        customButtonGroup={<ButtonGroup />}
                        arrows={false}
                        ssr={true}
                      >
                        {studentList?.map((item, i) => (
                          <StudentCard
                            item={item}
                            key={i}
                            student={student}
                            setSchoolId={setSchoolId}
                            setStudent={setStudent}
                            setDiscipline={setDiscipline}
                            setClass_type={setClass_type}
                            setAreaId={setAreaId}
                            setAge_group={setAge_group}
                            setSelectedTiming={setSelectedTiming}
                          />
                        ))}
                      </Carousel>
                    ) : (
                      <div className="text-center">No student added.</div>
                    )}
                  </div>
                </div>
              )}

              <div className="col-sm-12 col-md-12 col-lg-12">
                <hr />
              </div>
              {showArea && (
              <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                <div className="d-flex align-items-center">
                  <span>All Regions:</span>
                  <div className="form-style mw-auto ms-2">
                    <div className="input-container">
                      <select
                        className="form-control ps-4 pe-5 form-select"
                        value={areaId || undefined}
                        onChange={(e) => {
                          const val = e.target.value;
                          setAreaId(val);
                        }}
                      >
                        <option value="">Region*</option>
                        {areacodeList?.map((item, i) => (
                          <option value={item?.id || ""} key={i}>
                            {item?.areacode}
                          </option>
                        ))}
                      </select>
                      <img
                        src="assets/img/address.png"
                        className="input-img"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              )}
              {areaId && (
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  <div className="d-flex align-items-center">
                    <span>All Location:</span>
                    <div className="form-style mw-auto ms-2">
                      <div className="input-container">
                        <select
                          className="form-control ps-4 pe-5 form-select"
                          value={schoolId || undefined}
                          onChange={(e) => {
                            const val = e.target.value;
                            setSchoolId(val);
                          }}
                        >
                          <option value="">Location*</option>
                          {schoolList?.map((item, i) => (
                            <option value={item?.id || ""} key={i}>
                              {item?.name}
                            </option>
                          ))}
                        </select>
                        <img
                          src="assets/img/address.png"
                          className="input-img"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {schoolId &&
                schoolList
                  ?.filter((item) => {
                    return item.id === parseInt(schoolId);
                  })
                  ?.map((item, i) => (
                    <div className="col-sm-12 col-md-12 col-lg-12 mt-3" key={i}>
                      <div className="bg-white p-3 rounded expandible">
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12 mb-2 text-capitalize">
                            <h4>{item?.name}</h4>
                            <p className="mb-2">
                              <img
                                src="assets/img/address.png"
                                alt=""
                                className="me-1"
                              />
                              {item?.address}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  
              {schoolId && areaId && (
                
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  {classListLoader ? (
                    <Loader />
                  ) : (
                    
                    <div
                      className="accordion Classes-colles"
                      id="accordionExample"
                    >
                      <style>
                        {`
                          .custom-collapse-btn.collapsed .custom-chevron {
                            transform: rotate(0deg);
                          }
                          .custom-collapse-btn:not(.collapsed) .custom-chevron {
                            transform: rotate(180deg);
                          }
                          .custom-chevron {
                            transition: transform 0.3s ease;
                          }
                        `}
                      </style>
                      {monthlyList.length > 0 && <center>Click below to book your space!</center>}  
                      {
                        monthlyList?.map((item, i) => {
                          console.log('item', item);
                          let isClassAvailableTillMembershipDate =
                            ClassTillMembership(i);
                          return (
                            <div
                              className="bg-white p-2 text-capitalize mt-3"
                              key={i}
                            >
                              <div className="accordion-item border-0 rounded mb-3 shadow-sm" style={{ overflow: 'hidden' }}>
                                <h2 className="accordion-header" id="heading1">
                                  <button
                                    className="w-100 bg-transparent border-0 p-3 text-start custom-collapse-btn collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse1${item.id}`}
                                    aria-expanded="true"
                                    aria-controls="collapse1"
                                    style={{ outline: "none", boxShadow: "none" }}
                                    onClick={() => {
                                      setTeacherId(item?.assigned_teacher_id);
                                      setOpenClassFor(item?.id);
                                    }}
                                  >
                                    <div className="d-flex w-100 justify-content-between align-items-center flex-wrap flex-md-nowrap gap-3">
                                      <div className="d-flex align-items-center flex-grow-1">
                                        <div className="me-3">
                                          <img
                                            src={
                                              item?.image?.includes("http")
                                                ? item?.image
                                                : "assets/img/session.png"
                                            }
                                            className="rounded"
                                            style={{ width: "90px", height: "90px", objectFit: "cover" }}
                                            alt=""
                                          />
                                        </div>
                                        <div>
                                          <h5 className="mb-1 text-dark fw-bold">{item?.name}</h5>
                                          <p className="mb-1" style={{ fontSize: "14px", color: "#4f5d75" }}>
                                            {student?.length > 0 && student?.[0]?.trialAccountStatus === "1" && companySettings?.trial_apply == 1 && item?.free_class_available == 1 && student?.[0]?.schoolId == item?.schoolId ? (
                                            <>
                                              {item?.child_price && (
                                                
                                                <span style={{ textDecoration: 'line-through' }}>
                                                  child{" "}
                                                  <span className="theme-color me-2" style={{ textDecoration: 'line-through' }}>
                                                    <i
                                                      className="fa fa-gbp me-1"
                                                      aria-hidden="true"
                                                    ></i>
                                                   {item?.child_price}
                                                  </span>
                                                  </span>
                                                
                                              )}
                                              {item?.adult_price && (
                                                <span style={{ textDecoration: 'line-through' }}>
                                                  adult
                                                  <span className="theme-color ms-2" style={{ textDecoration: 'line-through' }}>
                                                    <i
                                                      className="fa fa-gbp me-1"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {item?.adult_price}
                                                  </span>
                                                </span>
                                              )}
                                              <span className="theme-color fw-bold ms-2">
                                                Tester Session Price{"  "}
                                              </span>
                                              <span className="theme-color ms-2">
                                                adult:{"  "}
                                              </span>
                                              <span className="theme-color fw-bold ms-2">
                                                <i
                                                  className="fa fa-gbp me-1"
                                                  aria-hidden="true"
                                                ></i>
                                                {item?.free_class_charge_adult}
                                                {/* {student?.[0]?.trial_class_price} */}
                                                {"  "}
                                              </span>
                                              <span className="theme-color ms-2">
                                                child:{"  "}
                                              </span>
                                              <span className="theme-color fw-bold ms-2">
                                                <i
                                                  className="fa fa-gbp me-1"
                                                  aria-hidden="true"
                                                ></i>
                                                {item?.free_class_charge}
                                              </span>
                                              
                                            </>
                                          ) : (
                                            <>
                                              {item?.child_price && (
                                                <>
                                                  child{" "}
                                                  <span className="theme-color me-2">
                                                    <i
                                                      className="fa fa-gbp me-1"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {item?.child_price}
                                                  </span>
                                                </>
                                              )}
                                              {item?.adult_price && (
                                                <>
                                                  adult
                                                  <span className="theme-color ms-2">
                                                    <i
                                                      className="fa fa-gbp me-1"
                                                      aria-hidden="true"
                                                    ></i>
                                                    {item?.adult_price}
                                                  </span>
                                                </>
                                              )}
                                            </>
                                          )}
                                          </p>
                                          <div style={{ fontSize: "14px", color: "#6c757d", marginTop: "4px" }}>
                                            <i className="fa fa-map-marker me-2"></i>
                                            {item?.school_details?.address || item?.school_details?.name || "NA"}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="text-center ms-md-3 mt-3 mt-md-0 d-flex flex-column align-items-center">
                                        <div className="rounded-circle text-white d-flex align-items-center justify-content-center mb-1 shadow-sm" style={{ width: "48px", height: "48px", fontSize: "20px", backgroundColor: "#1d6bf3", cursor: "pointer" }}>
                                          <i className="fa fa-chevron-down custom-chevron"></i>
                                        </div>
                                        <span className="fw-bold" style={{ fontSize: "14px", color: "#1d6bf3" }}>View<br/>Sessions</span>
                                      </div>
                                    </div>
                                  </button>
                                </h2>
                                <div
                                  id={`collapse1${item.id}`}
                                  className={
                                    open && openClassFor === item?.id
                                      ? "accordion-collapse collapse show"
                                      : "accordion-collapse collapse "
                                  }
                                  aria-labelledby="heading1"
                                  data-bs-parent="#accordionExample"
                                >
                                  {item.booking_type == 1 && (
                                    <div>
                                      <div className="accordion-body">
                                    {classListLoader ? (
                                      <Loader /> 
                                    ) : (
                                    // ) : isTrialConsumed && companySettings?.membership == 1 ? (
                                    //   <span className="text-danger">
                                    //     You have consumed your trial account
                                    //     lessons. Kindly upgrade your membership
                                    //     to start booking.
                                    //   </span>
                                    // ) : !isActiveMembership && companySettings?.membership == 1 ? (
                                    //   <span className="text-danger">
                                    // r    You membership is expired. Kindly renew
                                    //     your membership to start booking.
                                    //   </span>
                                    // ) : !isClassAvailableTillMembershipDate && companySettings?.membership == 1 ? (
                                    //   <span className="text-red">
                                    //     No available classes before your
                                    //     membership expiry date. Kindly upgrade
                                    //     your membership to start booking.
                                    //   </span>
                                    // ) : isActiveMembership || companySettings?.membership == 1 ? (
                                      <div className="row student-container">
                                        {item?.time_slot_list?.map((timeSlotItem, timeSlotIndex) => (
                                        <div className="row student-container" id={`schoolClass${timeSlotItem.id}`}>
                                          {/* Display month and year */}
                                          <h4 className="mb-3 text-center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem', color:'#299cd7', textTransform: 'uppercase' }} key={`month-year-${timeSlotIndex}`}>
                                                {timeSlotItem.block_name}
                                                {console.log(student[0], item)}
                                                
                                                { (student?.length > 0 && student?.[0]?.trialAccountStatus != 1 && item.booking_type==true && item?.time_slot_list?.length > 0) && (
                                                  <div style={{ display: 'block', marginLeft: '5px' }}> {/* Wrapper for the checkbox */}
                                                    <input 
                                                      type="checkbox" 
                                                      id={`selactall${timeSlotItem.id}`} 
                                                      className="checkBoxClass"
                                                      ref={setSelectRef(`ref${timeSlotItem.id}`)} // Assign the ref dynamically
                                                      onChange={(event) => handleSelectAllChange(`ref${timeSlotItem.id}`, `schoolClass${timeSlotItem.id}`, isClassAvailableTillMembershipDate, `selactall${timeSlotItem.id}`)}
                                                      style={{ display: 'block' }} // Keep checkbox as block
                                                    />
                                                  </div>
                                                )}
                                          </h4>
                                          {timeSlotItem?.time_slot?.length > 0 ? (
                                            timeSlotItem?.time_slot?.map((itemm, slotIndex) => (
                                              <div
                                                className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3"
                                                key={`${timeSlotIndex}-${slotIndex}`}
                                              >
                                                <input
                                                  type="checkbox"
                                                  name="classes"
                                                  id={`blockclasses1${timeSlotIndex}${slotIndex}`}
                                                  className="checkBoxClass"
                                                  disabled={student?.[0]?.trialAccountStatus != 1} // Disable if trialAccountStatus is 1
                                                  onChange={(e) => {

                                                    if (e.target.disabled) {
                                                      toast.error("You cannot select this checkbox because your trial account status is not active.", {  autoClose: false,  closeButton: true});
                                                    }

                                                    if (userDetail?.consent?.length === 0) {
                                                      toast.error(
                                                        "Kindly fill the consent for your profile to start booking.", {  autoClose: false,  closeButton: true}
                                                      );
                                                    } else {
                                                      if (itemm?.isCancelled && e.target.checked) {
                                                        toast.error("Class has been cancelled.", {  autoClose: false,  closeButton: true});
                                                      } else if (itemm?.is_required_new_membership && companySettings?.membership == 1 && e.target.checked) {
                                                        setIsShowmembershipExtend(true)
                                                        //toast.error("Your membership will expire before this class, so you can not choose this lesson, please renew your membership");
                                                      }else {
                                                        if (student?.length > 0) {
                                                          if (userDetail?.wallet < 0) {
                                                            navigate("/make-payment", {
                                                              state: {
                                                                amount: userDetail?.wallet,
                                                                payment_for: "wallet",
                                                              },
                                                            });
                                                            toast.error(
                                                              "Kindly clear your pending wallet amount to continue booking.", {  autoClose: false,  closeButton: true}
                                                            );
                                                          } else {
                                                            if (itemm?.isBooked && e.target.checked) {
                                                              e.preventDefault();
                                                              e.stopPropagation();
                                                              e.target.checked = false; // Uncheck the checkbox
                                                              toast.error(
                                                                "You have already booked this time slot.", {  autoClose: false,  closeButton: true}
                                                              );
                                                            } else {
                                                              if (itemm.isAddedInCart && e.target.checked) {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                e.target.checked = false; // Uncheck the checkbox
                                                                toast.error("Item already added in cart.", {  autoClose: false,  closeButton: true});
                                                              } else {
                                                                if (
                                                                  itemm?.available_seats > 0 &&
                                                                  itemm?.available_seats <= item?.total_seats
                                                                ) { 
                                                                    const bookingCutoffHours = Number(itemm?.booking_cutoff_hours);
                                                                    if (!Number.isNaN(bookingCutoffHours) && bookingCutoffHours > 0) {
                                                                      const classStart = moment(
                                                                        `${itemm?.date} ${itemm?.start_time}`,
                                                                        "YYYY-MM-DD HH:mm:ss"
                                                                      );
                                                                      const hoursUntilClass = classStart.diff(moment(), "hours", true);

                                                                      if (hoursUntilClass <= bookingCutoffHours) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                        e.target.checked = false; // Uncheck the checkbox
                                                                        toast.error(
                                                                          "Sorry, online booking is closed for this time slot. Please contact support for emergency bookings.", {  autoClose: false,  closeButton: true}
                                                                        );
                                                                        return;
                                                                      }
                                                                    }
                                                                    console.log(
                                                                      itemm,
                                                                      item,
                                                                      "Item to add to"
                                                                    );
                                                                    let innerTimeSlot = itemm;
                                                                    let outerClassDetail = item;
                                                                    let outerIndex = timeSlotIndex;
                                                                    let innerIndex = slotIndex;
                                                                    handleTimeSlot(
                                                                      e,
                                                                      innerTimeSlot,
                                                                      outerClassDetail,
                                                                      outerIndex,
                                                                      innerIndex
                                                                    );
                                                                } else {
                                                                  e.preventDefault();
                                                                  e.stopPropagation();
                                                                  e.target.checked = false; // Uncheck the checkbox
                                                                  toast.error(
                                                                    "Sorry, all the available seats are booked for this time slot.", {  autoClose: false,  closeButton: true}
                                                                  );
                                                                }
                                                              }
                                                            }
                                                          }
                                                        } else {
                                                          toast.error("Kindly select a student.", {  autoClose: false,  closeButton: true});
                                                        }
                                                      }
                                                    }
                                                  }}
                                                />
                                                <label
                                                  htmlFor={`blockclasses1${timeSlotIndex}${slotIndex}`}
                                                  className="student__details"
                                                  onClick={ (e)=>{
                                                    if (document.getElementById(`blockclasses1${timeSlotIndex}${slotIndex}`).disabled) {
                                                      toast.error("Please note: As an active member, you can only book termly. Single lesson booking is not available.", 
                                                        {  autoClose: false,  closeButton: true}
                                                      );                                                      
                                                      return; // Exit the function if disabled
                                                    }
                                                  }
                                                }
                                                >
                                                  <h5>
                                                    {moment(itemm?.date).format("dddd")}{" "}
                                                    {moment(itemm?.date).format("DD MMM")}
                                                  </h5>
                                                  <p className="mb-0">
                                                    <label className="theme-color">
                                                      {itemm?.time_slot_for === "both"
                                                        ? "Age Groups: "
                                                        : "Age Group: "}
                                                    </label>{" "}
                                                    {itemm?.time_slot_for === "both"
                                                      ? `Adult | Child`
                                                      : itemm?.time_slot_for}
                                                  </p>
                                                  <p className="mb-0">
                                                    <label className="theme-color">Time:</label>{" "}
                                                    {moment(itemm?.start_time, "hh:mm:ss").format("hh:mm a")} -{" "}
                                                    {moment(itemm?.end_time, "hh:mm:ss").format("hh:mm a")}
                                                  </p>
                                                  <p className="d-flex justify-content-between">
                                                    <span
                                                      className={
                                                        itemm?.isCancelled ? "text-danger" : "text-success"
                                                      }
                                                    >
                                                      Status:{" "}
                                                      {itemm?.isCancelled ? "Cancelled" : "Active"}
                                                    </span>
                                                    <span>
                                                      {itemm?.isBooked && (
                                                        <span className="text-danger">
                                                          Already Booked
                                                        </span>
                                                      )}
                                                      {itemm?.isAddedInCart && (
                                                        <span className="text-danger">
                                                          Already in Cart
                                                        </span>
                                                      )}
                                                    </span>
                                                  </p>
                                                </label>
                                              </div>
                                            ))
                                          ) : (
                                            <span key={`no-classes-${timeSlotIndex}`}>No classes found.</span>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                                  {item.booking_type == 0 && (
                                    <div>
                                      <div className="accordion-body">
                                        <div className="calendar">
                                          <div className="month mb-3" >
                                            <ul>
                                              <li
                                                className="prev cursor-pointer"
                                                onClick={(event) => {
                                                  if (index === 0) {
                                                    setIndex(
                                                      item?.time_slot_list?.length -
                                                        1
                                                    );
                                                  } else if (
                                                    index <=
                                                    item?.time_slot_list?.length - 1
                                                  ) {
                                                    setIndex(index - 1);
                                                  } else {
                                                    setIndex(0);
                                                  }
                                                }}
                                              >
                                                &#10094;
                                              </li>
                                              <li>
                                                {item?.time_slot_list[index]?.month}{" "}
                                                {item?.time_slot_list[index]?.year}
                                              </li>
                                              <li
                                                className="next cursor-pointer"
                                                onClick={() => {
                                                  if (
                                                    index <
                                                    item?.time_slot_list?.length - 1
                                                  ) {
                                                    setIndex(index + 1);
                                                  } else {
                                                    setIndex(0);
                                                  }
                                                }}
                                              >
                                                &#10095;
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                        {classListLoader ? (
                                          <Loader /> ) :
                                        //  isTrialConsumed && companySettings?.membership == 1 ? (
                                        //   <span className="text-danger">
                                        //     You have consumed your trial account
                                        //     lessons. Kindly upgrade your membership
                                        //     to start booking.
                                        //   </span>
                                        // ) : !isActiveMembership && companySettings?.membership == 1 ? (
                                        //   <span className="text-danger">
                                        // r    You membership is expired. Kindly renew
                                        //     your membership to start booking.
                                        //   </span>
                                        // ) : !isClassAvailableTillMembershipDate && companySettings?.membership == 1 ? (
                                        //   <span className="text-red">
                                        //     No available classes before your
                                        //     membership expiry date. Kindly upgrade
                                        //     your membership to start booking.
                                        //   </span>
                                        // ) : isActiveMembership || companySettings?.membership == 1 ?
                                         (
                                          <div className="row student-container">
                                          
                                          {item?.time_slot_list?.[index]
                                          ?.time_slot?.length > 0 ? (
                                          item?.time_slot_list?.[
                                            index
                                          ]?.time_slot?.map((itemm, ind) => (
                                            <div
                                              className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-3"
                                              key={ind}                                              
                                            >
                                              <input
                                                type="checkbox"
                                                name="classes"
                                                id={`classes1${ind}${i}`}
                                                className="checkBoxClass"
                                                checked={itemm?.checked}
                                                onChange={(e) => {
                                                  if(isTrialConsumed && companySettings?.membership == 1 ){ 
                                                     e.preventDefault();
                                                     e.stopPropagation();
                                                     e.target.checked = false;
                                                     setIsShowmembershipPurchase(true);
                                                     return;
                                                    //toast.error("You have consumed your trial account lessons. Kindly upgrade your membership to start booking.");
                                                  }else if(!isActiveMembership && companySettings?.membership == 1){ 
                                                     e.preventDefault();
                                                     e.stopPropagation();
                                                     e.target.checked = false;
                                                     setIsShowmembershipRenew(true);
                                                     return;
                                                    //toast.error("Your membership is expired. Kindly renew your membership to start booking.");
                                                  }else if(!isClassAvailableTillMembershipDate && companySettings?.membership == 1){
                                                     e.preventDefault();
                                                     e.stopPropagation();
                                                     e.target.checked = false;
                                                     setIsShowmembershipExtend(true);
                                                     return;
                                                    //toast.error("No available classes before your membership expiry date. Kindly upgrade your membership to start booking.");
                                                  }else{

                                                  }
                                                        if (userDetail?.consent?.length === 0) {
                                                          toast.error(
                                                            "Kindly fill the consent for your profile to start booking.", {  autoClose: false,  closeButton: true}
                                                          );
                                                        } else {
                                                          if (itemm?.isCancelled && e.target.checked) {
                                                            toast.error("Class has been cancelled.", {  autoClose: false,  closeButton: true});
                                                          } else if (itemm?.is_required_new_membership && companySettings?.membership == 1 && e.target.checked) {
                                                            setIsShowmembershipExtend(true)
                                                            //toast.error("Your membership will expire before this class, so you can not choose this lesson, please renew your membership");
                                                          } else {
                                                            if (student?.length > 0) {
                                                              if (userDetail?.wallet < 0) {
                                                                navigate("/make-payment", {
                                                                  state: {
                                                                    amount: userDetail?.wallet,
                                                                    payment_for: "wallet",
                                                                  },
                                                                });
                                                                toast.error(
                                                                  "Kindly clear your pending wallet amount to continue booking.", {  autoClose: false,  closeButton: true}
                                                                );
                                                              } else {
                                                                if (itemm?.isBooked && e.target.checked) {
                                                                  e.preventDefault();
                                                                  e.stopPropagation();
                                                                  e.target.checked = false; // Uncheck the checkbox
                                                                  toast.error(
                                                                    "You have already booked this time slot.", {  autoClose: false,  closeButton: true}
                                                                  );
                                                                } else {
                                                                  if (itemm.isAddedInCart && e.target.checked) {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                    e.target.checked = false; // Uncheck the checkbox
                                                                    toast.error("Item already added in cart.", {  autoClose: false,  closeButton: true});
                                                                  } else {
                                                                    if (
                                                                      itemm?.available_seats > 0 &&
                                                                      itemm?.available_seats <= item?.total_seats
                                                                    ) {
                                                                      const bookingCutoffHours = Number(itemm?.booking_cutoff_hours);
                                                                      if (!Number.isNaN(bookingCutoffHours) && bookingCutoffHours > 0) {
                                                                        const classStart = moment(
                                                                          `${itemm?.date} ${itemm?.start_time}`,
                                                                          "YYYY-MM-DD HH:mm:ss"
                                                                        );
                                                                        const hoursUntilClass = classStart.diff(moment(), "hours", true);
                                                                        
                                                                        console.log("Booking cutoff check:", {
                                                                          date: itemm?.date,
                                                                          start_time: itemm?.start_time,
                                                                          classStart: classStart.format(),
                                                                          currentTime: moment().format(),
                                                                          hoursUntilClass,
                                                                          bookingCutoffHours,
                                                                          shouldBlock: hoursUntilClass < bookingCutoffHours
                                                                        });

                                                                        if (hoursUntilClass < bookingCutoffHours) {
                                                                          e.preventDefault();
                                                                          e.stopPropagation();
                                                                          e.target.checked = false; // Uncheck the checkbox
                                                                          toast.error(
                                                                            "Sorry, online booking is closed for this time slot. Please contact support for emergency bookings.", {  autoClose: false,  closeButton: true}
                                                                          );
                                                                          return;
                                                                        }
                                                                      }
                                                                      console.log(
                                                                        itemm,
                                                                        item,
                                                                        "Item to add to"
                                                                      );
                                                                      let innerTimeSlot = itemm;
                                                                      let outerClassDetail = item;
                                                                      let outerIndex = i;
                                                                      let innerIndex = ind;
                                                                      
                                                                      handleTimeSlot(
                                                                        e,
                                                                        innerTimeSlot,
                                                                        outerClassDetail,
                                                                        outerIndex,
                                                                        innerIndex
                                                                      );
                                                                    } else {
                                                                      e.preventDefault();
                                                                      e.stopPropagation();
                                                                      e.target.checked = false; // Uncheck the checkbox
                                                                      toast.error(
                                                                        "Sorry, all the available seats are booked for this time slot.", {  autoClose: false,  closeButton: true}
                                                                      );
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            } else {
                                                              toast.error("Kindly select a student.", {  autoClose: false,  closeButton: true});
                                                            }
                                                          }
                                                        }
                                                      }}
                                                    />
                                                    <label
                                                      htmlFor={`classes1${ind}${i}`}
                                                      className="student__details"
                                                    >
                                                      <h5>
                                                        {moment(itemm?.date).format("dddd")}{" "}
                                                        {moment(itemm?.date).format("DD MMM")}
                                                      </h5>
                                                      <p className="mb-0">
                                                        <label className="theme-color">
                                                          {itemm?.time_slot_for === "both"
                                                            ? "Age Groups: "
                                                            : "Age Group: "}
                                                        </label>{" "}
                                                        {itemm?.time_slot_for === "both"
                                                          ? `Adult | Child`
                                                          : itemm?.time_slot_for}
                                                      </p>
                                                      <p className="mb-0">
                                                        <label className="theme-color">Time:</label>{" "}
                                                        {moment(itemm?.start_time, "hh:mm:ss").format("hh:mm a")} -{" "}
                                                        {moment(itemm?.end_time, "hh:mm:ss").format("hh:mm a")}
                                                      </p>
                                                      <p className="d-flex justify-content-between">
                                                        <span
                                                          className={
                                                            itemm?.isCancelled ? "text-danger" : "text-success"
                                                          }
                                                        >
                                                          Status:{" "}
                                                          {itemm?.isCancelled ? "Cancelled" : "Active"}
                                                        </span>
                                                        <span>
                                                          {itemm?.isBooked && (
                                                            <span className="text-danger">
                                                              Already Booked
                                                            </span>
                                                          )}
                                                          {itemm?.isAddedInCart && (
                                                            <span className="text-danger">
                                                              Already in Cart
                                                            </span>
                                                          )}
                                                        </span>
                                                      </p>
                                                    </label>
                                                  </div>
                                                ))
                                              ) : (
                                                <span>No classes found.</span>
                                              )}
                                        </div>
                                        
                                        ) }
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                      }

                      <div className="row">
                        {selectedTiming?.length > 0 && (
                          <div className="col-sm-12 col-md-12 col-lg-12 text-center mb-3">
                            <button
                              className="btn btn-submit fs-5 mb-1 w-auto"
                              type="button"
                              onClick={() => {
                                if (userDetail?.wallet < 0) {
                                  navigate("/make-payment", {
                                    state: {
                                      amount: userDetail?.wallet,
                                      payment_for: "wallet",
                                    },
                                  });
                                  toast.error(
                                    "Kindly clear your pending wallet amount to continue booking.", {  autoClose: false,  closeButton: true}
                                  );
                                } else {
                                  handleAddToCart();
                                }
                              }}
                              disabled={addToCartSubmitting}
                            >
                              {addToCartSubmitting ? (
                                <Loader />
                              ) : (
                                <>
                                  {" "}
                                  <img
                                    src="assets/img/cart.png"
                                    className=""
                                    alt=""
                                  />{" "}
                                  Add to Cart
                                </>
                              )}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {companySettings?.events && student?.length > 0 && (
                <>
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                  <label className="fw-bold mt-3">
                    <h4>Events</h4>
                  </label>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 mt-3 position-relative">
                  <div className="owl-slider Studentevent-slider student-container bookClassEvents">
                    {student?.length > 0 && student?.[0]?.trialAccountStatus === "0" && companySettings?.membership == 1 ? (
                      <p className="text-danger">
                        Kindly purchase membership to book events.
                      </p>
                    ) : student?.length > 0 && isTrialConsumed && companySettings?.membership == 1 ? (
                      <span className="text-danger">
                        Kindly upgrade your membership to start booking events.
                      </span>
                    ) : !isActiveMembership && companySettings?.membership == 1 ? (
                      <span className="text-danger">
                        Your membership is expired. Kindly renew your membership
                        to start booking for events.
                      </span>
                    ) : defaultEventList?.length > 0 ? (
                      <Carousel
                        responsive={responsive}
                        renderButtonGroupOutside={true}
                        customButtonGroup={<ButtonGroup />}
                        arrows={false}
                        draggable={true}
                        swipeable={true}
                      >
                        {defaultEventList?.map((item, i) => (
                          <div className="mx-2" key={i}>
                            <div className="class__details bg-white p-2 cursor-pointer rounded h-160 position-relative w-100">
                              <div className="event-box-flex align-items-normal p-0">
                                <span>
                                  <img
                                    src={
                                      item?.image?.includes("http")
                                        ? item?.image
                                        : "assets/img/event.png"
                                    }
                                    className="event-img"
                                    alt=""
                                  />
                                </span>
                                <span className="event-content-wrapper">
                                  <h6 className="mb-1 ellipse fw-bold">
                                    {item?.name || "NA"}
                                  </h6>
                                  <p className="mb-0 fs-7 ellipse">
                                    {item?.discipline_details.name || "NA"}
                                  </p>
                                  <p className="mb-0 fs-7 ellipse">
                                    {item?.age_group.toLowerCase() === "both"
                                      ? "Adult |Child"
                                      : item?.age_group}
                                  </p>
                                  <p className="mb-0 fs-7 ellipse">
                                    <img
                                      src="assets/img/address.png"
                                      className=""
                                      alt=""
                                    />{" "}
                                    {item?.school_details?.name || "NA"}
                                  </p>
                                  <p className="mb-0 fs-7">
                                    <img
                                      src="assets/img/date-of-birth.png"
                                      className=""
                                      alt=""
                                    />{" "}
                                    {item?.date
                                      ? moment(item?.date).format("DD MMM YYYY")
                                      : "NA"}
                                  </p>
                                  {item?.levels?.length > 0 && (
                                    <p className="mb-0 fs-7 ellipse">
                                      <span>Levels: </span> {item?.levels?.length}
                                    </p>
                                  )}
                                </span>
                              </div>
                              <div className="bookClassEventCard event-view-btns view-btns justify-content-sm-end eventButtons">
                                <button
                                  className="left-seats py-1 px-2 fs-7 cursor-pointer mx-1"
                                  onClick={() => {
                                    let studentId = student[0]?.id;
                                    navigate(`/event/${item?.id}/${studentId}`);
                                  }}
                                >
                                  View Event
                                </button>
                                {student.every((element) => {
                                  return (
                                    element.trialAccountStatus === "3" &&
                                    element?.membership_details !== null
                                  );
                                }) ? (
                                  <button
                                    className="left-seats py-1 px-2 fs-7 cursor-pointer"
                                    onClick={() => {
                                      const studentDiscipline = [...student]?.[0]
                                        ?.student_type;

                                      const eventDiscipline =
                                        item?.age_group?.toLowerCase();

                                      const isSameDiscipline =
                                        studentDiscipline === eventDiscipline ||
                                        eventDiscipline === "both";

                                      if (userDetail?.consent?.length === 0) {
                                        toast.error(
                                          "Kindly fill the consents for your profile to start booking.", {  autoClose: false,  closeButton: true}
                                        );
                                      } else {
                                        if (isSameDiscipline) {
                                          if (item?.levels?.length > 0) {
                                            setLevelShow(!levelShow);
                                            setLevels(item?.levels);
                                            setSelectedEvent(item);
                                          } else {
                                            if (!item?.isBooked) {
                                              if (!item?.isAddedInCart) {
                                                let evnt = item;
                                                let levl = [];
                                                handleAddEventToCart(evnt, levl);
                                              } else {
                                                toast.error(
                                                  "Event already added in cart.", {  autoClose: false,  closeButton: true}
                                                );
                                              }
                                            } else {
                                              toast.error(
                                                "Already booked for this event.", {  autoClose: false,  closeButton: true}
                                              );
                                            }
                                          }
                                        } else {
                                          toast.error(
                                            `${studentDiscipline} can not book event for ${eventDiscipline}`, {  autoClose: false,  closeButton: true}
                                          );
                                        }
                                      }
                                    }}
                                    disabled={
                                      (item?.levels?.length === 0 &&
                                        item?.isAddedInCart) ||
                                      (item?.levels?.length === 0 &&
                                        item?.isBooked)
                                    }
                                  >
                                    {item?.levels?.length === 0 &&
                                    item?.isAddedInCart
                                      ? "Added to Cart"
                                      : item?.levels?.length === 0 &&
                                        item?.isBooked
                                      ? "Already Booked"
                                      : "Add to cart"}
                                  </button>
                                ) : (
                                  <span
                                    className="px-1 theme-color"
                                    onClick={() => {
                                      if (student?.length > 0) {
                                        navigate(`/plans/${student?.[0]?.id}`);
                                      }
                                    }}
                                  >
                                    Upgrade to full Membership
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </Carousel>
                    ) : (
                      <div>No new events.</div>
                    )}
                  </div>
                </div>
                </>
              )}
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-4 col-xl-3 mb-3">
            <div className="py-4 px-3 record-listing h-100">
              {
                <div className="btn-accept btn-view w-auto" style={{
                  display: "inline-block",
                  maxWidth: "100%",
                  whiteSpace: "normal",
                  overflowWrap: "anywhere",
                  wordBreak: "break-word",
                  height: "auto",
                  lineHeight: "normal"
                }}>
                  Balance/Credit:{" "}
                  <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                  {userDetail?.wallet || 0}
                </div>
              }

              <div
                className={
                  cartList?.length > 0 || cartEventList?.cart_data?.length > 0
                    ? "overflowYScroll"
                    : ""
                }
              >
                {cartList?.length > 0
                  ? cartList?.map((item, i) => (
                      <div className="bg-white p-2 mt-4 rounded h-auto shadow position-relative">
                        <div className="row">
                          <div className="col-sm-6 col-md-6 col-lg-9 mb-2">
                            <div className="event-box-flex BookClassCartCard CartStdtTble">
                              <span>
                                <img
                                  src={
                                    item?.class_details?.image?.includes("http")
                                      ? item?.class_details?.image
                                      : "assets/img/session.png"
                                  }
                                  className="event-img"
                                  alt=""
                                />
                              </span>
                              <span className="">
                                <h4>{item?.class_details?.name}</h4>
                                <p className="fw-bold mb-1">
                                  {item?.time_slot_list
                                    ?.map((item) => {
                                      return `${moment(item?.date).format(
                                        "DD MMM"
                                      )}, ${moment(
                                        item?.start_time,
                                        "HH:mm:ss"
                                      ).format("hh:mm a")}-${moment(
                                        item?.end_time,
                                        "HH:mm:ss"
                                      ).format("hh:mm a")}`;
                                    })
                                    .join(", ")}
                                </p>
                                {item?.student_list?.map((item, i) => (
                                  <p className="mb-0" key={i}>
                                    {`${item?.student_details?.first_name} ${item?.student_details?.last_name}`}
                                  </p>
                                ))}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-3 mb-2 text-end">
                            <button className="btn btn-submit closeIcon p-0 mt-0 w-auto bg-transparent">
                              <img
                                src="assets/img/closeIcon.png"
                                className="img-fluid"
                                alt=""
                                onClick={() => {
                                  setDelId(item?.cart_id);
                                  delToggle();
                                }}
                              />
                            </button>

                            <h5 className="theme-color h5PriceClass">
                              <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                              {item?.amount}
                            </h5>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
                {cartEventList?.cart_data?.length > 0
                  ? cartEventList?.cart_data?.map((item) => (
                      <div
                        className="bg-white p-2 mt-4 rounded h-auto shadow position-relative"
                        key={item?.id}
                      >
                        <div className="row">
                          <div className="col-sm-6 col-md-6 col-lg-9 mb-2">
                            <div className="event-box-flex BookClassCartCard CartStdtTble">
                              <span>
                                <img
                                  src={
                                    item?.event_details?.image?.includes("http")
                                      ? item?.event_details?.image
                                      : "assets/img/event.png"
                                  }
                                  className="event-img"
                                  alt=""
                                />
                              </span>
                              <span className="mb-0">
                                <h4>{item?.event_details?.name}</h4>
                                <p className="mb-0 text-muted">
                                  {item?.school_details?.name}
                                </p>
                                <p>
                                  On: {moment(item?.date).format("DD MMM YYYY")}
                                </p>
                                {item?.student_list?.map((item, i) => (
                                  <p className="mb-0" key={i}>
                                    {`${item?.student_details?.first_name} ${item?.student_details?.last_name}`}
                                  </p>
                                ))}
                              </span>
                            </div>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-3 mb-2 text-end">
                            <button className="btn btn-submit closeIcon p-0 mt-0 w-auto bg-transparent">
                              <img
                                src="assets/img/closeIcon.png"
                                className="img-fluid"
                                alt=""
                                onClick={() => {
                                  setDelId(item?.cart_id);
                                  toggle2();
                                }}
                              />
                            </button>

                            <h5 className="theme-color h5PriceClass">
                              <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                              {item?.amount
                                ? item?.amount
                                : item?.event_details?.child_price
                                ? item?.event_details?.child_price
                                : item?.event_details?.adult_price
                                ? item?.event_details?.adult_price
                                : "NA"}
                            </h5>
                          </div>
                        </div>
                      </div>
                    ))
                  : null}
              </div>

              {(cartList?.length > 0 ||
                cartEventList?.cart_data?.length > 0) && (
                <div className="text-end">
                  <button
                    className="btn btn-submit fs-5 mb-1 w-auto"
                    onClick={() => {
                      navigate("/cart");
                    }}
                  >
                    <img src="assets/img/cart.png" className="" alt="" /> Go To
                    Cart
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {delId && (
          <Delete
            show={delOpen}
            handleShow={(stat) => {
              if (stat === "confirm") {
                confirmDelete();
              }
              setDelId("");
              delToggle();
            }}
          />
        )}

        {levelShow && levels.length > 0 && selectedEvent && (
          <EventLevels
            show={levelShow}
            handleShow={() => {
              setLevelShow(!levelShow);
              // setLevels([]);
              // setSelectedEvent(null);
            }}
            setSelectedEvent={setSelectedEvent}
            child_price={selectedEvent?.child_price}
            adult_price={selectedEvent?.adult_price}
            levels={levels}
            setSelectedLevels={setSelectedLevels}
            onDone={(selectedLevel, child_price, adult_price) => {
              handleAddEventToCart(
                selectedEvent,
                selectedLevel,
                child_price,
                adult_price
              );
            }}
          />
        )}

        <Delete
          show={show}
          handleShow={(val) => {
            if (val === "confirm") {
              handleRemoveEventFromCart();
            }
            toggle2();
          }}
        />
      </div>
    </section>
    
    <Modal
      show={isShowmembershipExtend}
      onHide={() => {
        setIsShowmembershipExtend(false);
      }}
      size="md"
      centered
    >
      <Modal.Header closeButton style={{ color: '#2c58ab' }}>
        <h5>Extend Your Membership!</h5>
      </Modal.Header>
      <Modal.Body className="scrollable-modal-body text-center">
        <p style={{ fontSize: '15px', marginBottom: '20px' }}>
          You cannot select certain lessons that fall beyond your membership
          expiration date. To book those lessons, please extend your membership
          by clicking the button below.
        </p>
        <button
          className="btn btn-primary"
          onClick={() => {
            // handle extend membership click here
            if (student?.length > 0) {
              navigate(`/plans/${student?.[0]?.id}`);
            }
          }}
        >
          Extend Membership
        </button>
      </Modal.Body>
    </Modal>


     <Modal
      show={isShowmembershipPurchase}
      onHide={() => {
        setIsShowmembershipPurchase(false);
      }}
      size="md"
      centered
    >
      <Modal.Header closeButton style={{ color: '#2c58ab' }}>
        <h5>Purchase Membership!</h5>
      </Modal.Header>
      <Modal.Body className="scrollable-modal-body text-center">
        <p style={{ fontSize: '15px', marginBottom: '20px' }}>
          Purchase memebrship to book session by clicking the button below.
        </p>
        <button
          className="btn btn-primary"
          onClick={() => {
            // handle extend membership click here
            if (student?.length > 0 && student[0]) {
              navigate(`/plans/${student[0].id}`);
            }
          }}
        >
          Select Plan
        </button>
      </Modal.Body>
    </Modal>

      <Modal
      show={isShowmembershipRenew}
      onHide={() => {
        setIsShowmembershipRenew(false);
      }}
      size="md"
      centered
    >
      <Modal.Header closeButton style={{ color: '#2c58ab' }}>
        <h5>Renew Membership!</h5>
      </Modal.Header>
      <Modal.Body className="scrollable-modal-body text-center">
        <p style={{ fontSize: '15px', marginBottom: '20px' }}>
          Your membership is expired. Kindly renew your membership to start booking by clicking the button below.
        </p>
        <button
          className="btn btn-primary"
          onClick={() => {
            // handle extend membership click here
            if (student?.length > 0 && student[0]) {
              navigate(`/plans/${student[0].id}`);
            }
          }}
        >
          Select Plan
        </button>
      </Modal.Body>
    </Modal>
  </>
  );
}

export default BookClass;
